import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const NotFound = () => {
  const navigate = useNavigate();

  // Set HTTP status code for SEO
  useEffect(() => {
    // This helps search engines understand it's a 404 page
    document.title = '404 - Page Not Found | Dexreaction';
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center px-6">
      <Helmet>
        <title>404 - Page Not Found | Dexreaction</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="prerender-status-code" content="404" />
        <meta name="description" content="Page not found. The page you're looking for doesn't exist or has been moved." />
      </Helmet>
      
      <div className="text-center">
        {/* 404 Number */}
        <div className="mb-8">
          <h1 className="text-9xl md:text-[200px] font-bold bg-gradient-to-r from-purple-400 via-pink-400 to-blue-400 bg-clip-text text-transparent animate-pulse">
            404
          </h1>
        </div>

        {/* Emoji */}
        <div className="text-6xl mb-6 animate-bounce">
          🚀💫
        </div>

        {/* Message */}
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Page Not Found
        </h2>
        <p className="text-xl text-gray-300 mb-8 max-w-md mx-auto">
          Oops! The page you're looking for has drifted into space. Let's get you back on track.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button 
            onClick={() => navigate('/')}
            className="btn-primary text-lg px-8 py-3 flex items-center"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Back to Home
          </button>
          
          <button 
            onClick={() => navigate(-1)}
            className="btn-secondary text-lg px-8 py-3 flex items-center"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Go Back
          </button>
        </div>

        {/* Additional Info */}
        <div className="mt-12 p-6 bg-purple-500/10 border border-purple-500/30 rounded-lg max-w-md mx-auto">
          <p className="text-gray-300 text-sm">
            If you believe this is an error, please contact our support team at{' '}
            <a href="mailto:support@dexreaction.com" className="text-purple-400 hover:text-purple-300 underline">
              support@dexreaction.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
